import React from 'react';
import { Tooltip } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import './OrganizationItem.less';
import { OrgCredential } from '../../interfaces/organization';
import { ReactComponent as ExternalLinkIcon } from '../../assets/external-link.svg';
import OrganizationStatusIndicator from '../OrganizationStatusIndicator/OrganizationStatusIndicator';

interface OrganizationItemProps {
  cred: OrgCredential;
  connectOrg: (org: OrgCredential) => void;
}

const OrganizationItem: React.FC<OrganizationItemProps> = ({
  cred,
  connectOrg,
}) => {
  return (
    <div className="org-item">
      <span className="username-wrapper">
        <OrganizationStatusIndicator cred={cred} />
        <span className="username">{cred.username}</span>
      </span>
      <span className="org-item-actions">
        <Tooltip
          title={
            <>
              <span className="connect-org-tooltip">
                Connect to Salesforce Org <ExternalLinkIcon />
              </span>
            </>
          }
        >
          <LoginOutlined
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              connectOrg(cred);
            }}
          />
        </Tooltip>
      </span>
    </div>
  );
};

export default OrganizationItem;
